import { Combobox } from "@/components/ui/combobox"
import {
  localizationCache,
  useAppStateStore,
  useAutoTranslation,
  useLangStore,
} from "@/entities"
import { getDictionary, getDictionaryVersion } from "@/shared/api/dictionary"
import {
  DEFAULT_LANG_LIST,
  LANG_KEYS,
  UI_LANGUAGE_TRANSLATION_KEYS,
} from "@/shared/constants"
import { useTranslation } from "react-i18next"

export const ChangeLang = () => {
  const { t } = useAutoTranslation()
  const lang = useLangStore(s => s.lang)
  const setLang = useLangStore(s => s.setLang)
  const setAppLoading = useAppStateStore(s => s.setIsLoading)
  const { i18n } = useTranslation()

  const onChange = async (value: string) => {
    setAppLoading(true)
    const [cachedDictionary, serverVersion] = await Promise.all([
      localizationCache.getDictionary(value),
      getDictionaryVersion(),
    ])
    const downloadedDictionary =
      cachedDictionary &&
      (serverVersion === null ||
        cachedDictionary.translationVersion === serverVersion)
        ? null
        : await getDictionary(value)
    const dictionary =
      downloadedDictionary?.data ?? cachedDictionary?.data ?? {}
    if (Object.keys(dictionary).length === 0) {
      throw new Error("No dictionary found for the selected language")
    }
    i18n.addResourceBundle(value, "translation", dictionary)
    if (downloadedDictionary) {
      await localizationCache.saveDictionary(
        value,
        downloadedDictionary.data,
        downloadedDictionary.version
      )
    }
    await i18n.changeLanguage(value)
    setLang(value)
    setAppLoading(false)
  }

  const options = DEFAULT_LANG_LIST.map(lang => ({
    value: lang.lang,
    label: t(
      UI_LANGUAGE_TRANSLATION_KEYS[
        lang.lang as keyof typeof UI_LANGUAGE_TRANSLATION_KEYS
      ]
    ),
    pseudoId: lang.label,
  }))

  return (
    <Combobox
      options={options}
      placeholder={t(LANG_KEYS.CHANGE_LANGUAGE)}
      value={lang}
      onChange={onChange}
      optionItemClassName={"capitalize"}
    />
  )
}
